import { CardContent, CardHeader, Stack } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import MaterialTypography from "../../../components/MaterialTypography"
import MaterialButton from "../../../components/MaterialButton"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { useSnackbar } from "../../../context/popup"
import { useLoading } from "../../../components/Loading"
import { Add } from "@mui/icons-material"
import { deleteData, fetchData } from "../../../services"
import { setCurrentPage, setRowsPerPage, setTotalPages } from "./store/index.js";
import { useEffect, useState } from "react"
import Table from "../../../components/Table/index.js"

const FieldMappingList = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();

    const currentPage = useSelector((state) => state?.apiFieldMappingStore?.currentPage);
    const rowsPerPage = useSelector((state) => state?.apiFieldMappingStore?.rowsPerPage);
    const totalPages = useSelector((state) => state?.apiFieldMappingStore?.totalPages);

    const [fieldMappingData, setFieldMappingData] = useState([]);
    const [isRefresh, setIsRefresh] = useState(false);
    const [search, setSearch] = useState("");

    useEffect(() => {
        fetchFieldMappingList();
    },[isRefresh, currentPage, rowsPerPage, search])

    //List API
    const fetchFieldMappingList = async () => {
        setCircleLoading(true);
        try {
        const response = await fetchData(`/api-engine/field-mapping?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}`)        
        if(response?.success){
            setFieldMappingData(response?.data?.items);
            dispatch(setTotalPages(response?.data?.totalPages));     
        }
        else{
            //throw error
            showSnackbar("Error Fetching Insurer Api List", "error")
        }
        } catch (error) {
            console.error('Error Fetching Insurer Api List:', error);
            showSnackbar(error?.response?.data?.message, "error")
        }
        finally{
            setCircleLoading(false);
        }
    };

    //delete api function
    const handleDelete = async (row) => {
        try {
            const response = await deleteData(`/api-engine/field-mapping-delete`, {ids:[row?.id]});
            setIsRefresh(!isRefresh);
            if(response?.success){
                showSnackbar(response?.message, "success");
            }
            else{
                showSnackbar(response?.message, "error");
            }
        } catch (error) {
            console.error("Error deleting data:", error);
            showSnackbar("Error deleting Insurer Registry data", "error");
        }
    };

    //table mapping
    const fieldMappingTable = {
        columns: [
            {
            key: "sno",
            label: "S.No.",
            renderCell: (row) => row.sno,
            },            
            {
            key: "name",
            label: "Name",
            renderCell: (row) => row.name,
            },
            {
            key: "label",
            label: "Label",
            renderCell: (row) => row.label,
            },
            {
            key: "mappingConfig",
            label: "Mapping Config",
            // renderCell: (row) => row.dataType,
            isObject: true,
            },
            {
            key: "fieldCategory",
            label: "Field Category",
            renderCell: (row) => row.fieldCategory,
            },
            {
                key: "isActive",
                label: "Status",
                renderCell: (row) => (
                    <span>
                    {row.isActive ? (
                        <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
                    ) : (
                        <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
                    )}
                    </span>
                )
            },
            {
                key: "isRequired",
                label: "Required",
                renderCell: (row) => (
                    <span>
                    {row.isRequired ? (
                        <span style={{ color: "green", fontWeight: "bold" }}>Yes</span>
                    ) : (
                        <span style={{ color: "red", fontWeight: "bold" }}>No</span>
                    )}
                    </span>
                )
            },
        ],
        rows: fieldMappingData?.map((item, index) => ({
            id: item?.id,
            sno: index + 1,
            fieldCategory: item?.fieldCategory?.keyName || "",
            name: item?.name || "",
            mappingConfig: item?.mappingConfig || "",
            isActive: item?.isActive,
            isRequired: item?.isRequired
        })),
    };

    const actions = {
        edit: true,
        view: true,
        delete: true,

        onEdit: (row) => {
            navigate(`/api-integration-engine/field-dictionary/field-dictionary-details?pageType=edit&id=${row.id}`);
        },
        onView: (row) => {
            navigate(`/api-integration-engine/field-dictionary/field-dictionary-details?pageType=view&id=${row.id}`);
        },
        onDelete: (row) => handleDelete(row),
    };

    const handlePaginationChange = (page) => {
        dispatch(setCurrentPage(page));
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        dispatch(setRowsPerPage(rowsPerPage));
        dispatch(setCurrentPage(1));
    };

    const handleSearch = (value) => {
        setSearch(value);
    };
    

  return (
    <DashboardLayout>
        <CardHeader title={(
            <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            >
                <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                        Field Mapping List
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                        List of Field Mappings.
                    </MaterialTypography>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <MaterialButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        startIcon={<Add />}
                        onClick={() => navigate('/api-integration-engine/field-mapping/field-mapping-details')}
                    >
                        Field Mapping
                    </MaterialButton>
                </Stack>
            </Stack>
            )} 
        />
        <CardContent>
            <Table
            columns={fieldMappingTable?.columns}
            data={fieldMappingTable?.rows}
            actions={actions}
            pagination={{
                totalPages,
                currentPage,
                onPageChange: (page) => handlePaginationChange(page),
                rowsPerPage,
                onRowsPerPageChange: (rowsPerPage) => handleRowsPerPageChange(rowsPerPage),
                rowsPerPageOptions: [5, 10, 15, 20],
            }}
            getRowKey={(row) => row.id}
            className="custom-table"
            noDataLabel="No Field Mapping Data found"
            handleSearch={handleSearch}
            />
        </CardContent>
    </DashboardLayout>
  )
}

export default FieldMappingList